import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import StaffTeamMemberModal from './components/StaffTeamMemberModal/StaffTeamMemberModal';
import { ImagePropType, ObjectPropsPropType } from '../../../../../../services/proptypes';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props';
import TeamMember from '../../TeamMember';
import { HourPropType, LocationPropType, SocialMediaPropType } from '../../TeamMember.types';
var defaultProps = {
  photo: null,
  role: '',
  email: '',
  phone: '',
  description: '',
  locations: [],
  hours: [],
  social: [],
  buttonText: 'Book',
  buttonProps: {},
  showMoreInfoButton: true
};
export default function StaffTeamMember(_ref) {
  var photo = _ref.photo,
    name = _ref.name,
    role = _ref.role,
    email = _ref.email,
    phone = _ref.phone,
    description = _ref.description,
    locations = _ref.locations,
    hours = _ref.hours,
    social = _ref.social,
    onClick = _ref.onClick,
    buttonText = _ref.buttonText,
    buttonProps = _ref.buttonProps,
    showMoreInfoButton = _ref.showMoreInfoButton;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var _useSemanticUiProps = useSemanticUiProps(),
    getButtonProps = _useSemanticUiProps.getButtonProps;
  function openModal() {
    setShowModal(true);
  }
  function closeModal() {
    setShowModal(false);
  }
  var TeamMemberModal = /*#__PURE__*/React.createElement(TeamMember, {
    className: "staff-team-member"
  }, /*#__PURE__*/React.createElement(TeamMember.Photo, {
    src: photo
  }), /*#__PURE__*/React.createElement(TeamMember.Content, null, /*#__PURE__*/React.createElement(TeamMember.Name, {
    name: name
  }), /*#__PURE__*/React.createElement(TeamMember.Role, {
    role: role
  }), /*#__PURE__*/React.createElement(TeamMember.Description, {
    description: description
  }), /*#__PURE__*/React.createElement(TeamMember.Email, {
    email: email
  }), /*#__PURE__*/React.createElement(TeamMember.Phone, {
    phone: phone
  }), /*#__PURE__*/React.createElement(TeamMember.Location, {
    locations: locations
  }), /*#__PURE__*/React.createElement(TeamMember.Social, {
    social: social
  }), /*#__PURE__*/React.createElement(TeamMember.Schedule, {
    hours: hours
  }), /*#__PURE__*/React.createElement(TeamMember.Button, _extends({
    onClick: onClick,
    text: buttonText
  }, getButtonProps(buttonProps)))));
  return /*#__PURE__*/React.createElement(TeamMember, {
    className: "staff-team-member"
  }, /*#__PURE__*/React.createElement(StaffTeamMemberModal, {
    open: showModal,
    onClose: closeModal,
    teamMember: TeamMemberModal
  }), showMoreInfoButton && /*#__PURE__*/React.createElement(TeamMember.MoreInfoButton, {
    onClick: openModal
  }), /*#__PURE__*/React.createElement(TeamMember.Photo, {
    src: photo
  }), /*#__PURE__*/React.createElement(TeamMember.Content, null, /*#__PURE__*/React.createElement(TeamMember.Name, {
    name: name
  }), /*#__PURE__*/React.createElement(TeamMember.Role, {
    role: role
  }), /*#__PURE__*/React.createElement(TeamMember.Location, {
    locations: locations
  }), /*#__PURE__*/React.createElement(TeamMember.Social, {
    social: social
  }), /*#__PURE__*/React.createElement(TeamMember.Schedule, {
    hours: hours
  }), /*#__PURE__*/React.createElement(TeamMember.Button, _extends({
    onClick: onClick,
    text: buttonText
  }, getButtonProps(buttonProps)))));
}
StaffTeamMember.defaultProps = defaultProps;